import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { CustomHttpResponse, SupplierInvoiceSection } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierInvoiceSectionService {
  apiService: ApiHttpService<SupplierInvoiceSection> = inject(ApiHttpService);

  get(iri: string): Observable<SupplierInvoiceSection> {
    return this.apiService.get(iri).pipe(
      take(1),
      map((result: CustomHttpResponse<SupplierInvoiceSection>) => result.body),
    );
  }

  patch(iri: string, update: SupplierInvoiceSection): Observable<SupplierInvoiceSection> {
    return this.apiService
      .patch(iri, update)
      .pipe(map((result: CustomHttpResponse<SupplierInvoiceSection>) => result.body));
  }

  delete(entity: SupplierInvoiceSection) {
    return this.apiService.delete(`${entity['@id']}`).pipe(map((result) => result));
  }

  getForSupplierInvoice(iri: string): Observable<SupplierInvoiceSection[]> {
    return this.apiService
      .getMany(`${iri}/supplier_invoice_sections`)
      .pipe(map((result) => result.body['hydra:member']));
  }
}
